import { createLayoutApp } from "../layout/createLayoutApp";
import AuthorizationApp from "../authorization/AuthorizationAppDesktop.vue";

const mountEl = document.getElementById("authorization-app");
if (mountEl && mountEl.getAttribute("data-vue3") === "true") {
  const raw = mountEl.getAttribute("data-view-model");
  const viewModel = raw ? JSON.parse(raw) : null;
  const loginUrl = mountEl.getAttribute("data-login-url") ?? "";
  const antiForgeryHtml = mountEl.getAttribute("data-anti-forgery-html") ?? "";
  const app = createLayoutApp(AuthorizationApp, { viewModel, loginUrl, antiForgeryHtml });
  app.config.globalProperties.$mobile = false;
  app.mount(mountEl);
}
